var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgWallet = function SvgWallet(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8472 7.9803L13.8256 21.3896C13.6308 21.6265 13.2812 21.6606 13.0445 21.4658L4.68025 14.5825C4.44323 14.3874 4.4091 14.0367 4.60412 13.7995L15.6257 0.390119C15.8205 0.153246 16.17 0.119112 16.4068 0.313908L24.771 7.19722C25.0081 7.39239 25.0422 7.74306 24.8472 7.9803Z",
    fill: "#12B886"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1468 9.49141L15.6385 20.5302C15.3997 20.7253 15.0477 20.6905 14.8523 20.4524L7.95337 12.0461C7.75806 11.8079 7.7933 11.4567 8.03216 11.2615L21.5405 0.222804C21.7794 0.0276402 22.1314 0.0623621 22.3267 0.300486L29.2255 8.70686C29.421 8.94491 29.3857 9.29624 29.1468 9.49141Z",
    fill: "#20C997"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5766 8.37234V24.6202C30.5766 26.4334 29.1043 27.9032 27.2883 27.9032H7.04023C5.2241 27.9032 3.75195 26.4334 3.75195 24.6202V8.37234C3.75195 6.55922 5.2241 5.08936 7.04023 5.08936H27.2883C29.1043 5.08936 30.5766 6.55922 30.5766 8.37234Z",
    fill: "url(#paint0_linear_1729_2165)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9998 14.0105V18.9823C31.9998 19.806 31.3289 20.4738 30.5012 20.4738H28.6054C26.394 20.4738 24.5243 18.7293 24.507 16.5285C24.4981 15.417 24.9469 14.4104 25.6757 13.6824C26.4 12.964 27.3991 12.519 28.5031 12.519H30.5012C31.3289 12.519 31.9998 13.1868 31.9998 14.0105Z",
    fill: "#F06595"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5276 16.4963C29.5276 17.2424 28.9237 17.8471 28.1788 17.8471C27.434 17.8471 26.8301 17.2424 26.8301 16.4963C26.8301 15.7502 27.434 15.1455 28.1788 15.1455C28.9237 15.1455 29.5276 15.7502 29.5276 16.4963Z",
    fill: "#FFDEEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4266 27.9034H0.211862C0.0948231 27.9034 0 27.8086 0 27.6915V25.5846C0 25.4677 0.0948231 25.3728 0.211862 25.3728H10.4266C10.5435 25.3728 10.6384 25.4677 10.6384 25.5846V27.6915C10.6384 27.8086 10.5435 27.9034 10.4266 27.9034Z",
    fill: "#FFD43B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5545 25.3728H2.33979C2.22275 25.3728 2.12793 25.278 2.12793 25.161V23.054C2.12793 22.9371 2.22275 22.8423 2.33979 22.8423H12.5545C12.6715 22.8423 12.7663 22.9371 12.7663 23.054V25.161C12.7663 25.278 12.6715 25.3728 12.5545 25.3728Z",
    fill: "#FAB005"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4266 22.8421H0.211862C0.0948231 22.8421 0 22.7473 0 22.6302V20.5233C0 20.4063 0.0948231 20.3115 0.211862 20.3115H10.4266C10.5435 20.3115 10.6384 20.4063 10.6384 20.5233V22.6302C10.6384 22.7473 10.5435 22.8421 10.4266 22.8421Z",
    fill: "#FFD43B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6179 20.3115H3.40319C3.28623 20.3115 3.19141 20.2167 3.19141 20.0997V17.9927C3.19141 17.8758 3.28623 17.781 3.40319 17.781H13.6179C13.7349 17.781 13.8298 17.8758 13.8298 17.9927V20.0997C13.8298 20.2167 13.7349 20.3115 13.6179 20.3115Z",
    fill: "#FAB005"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.49 17.7811H1.27527C1.1583 17.7811 1.06348 17.6862 1.06348 17.5692V15.4623C1.06348 15.3453 1.1583 15.2505 1.27527 15.2505H11.49C11.607 15.2505 11.7018 15.3453 11.7018 15.4623V17.5692C11.7018 17.6862 11.607 17.7811 11.49 17.7811Z",
    fill: "#FFD43B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1729_2165",
    x1: 4,
    y1: 4.99976,
    x2: 29,
    y2: 28.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6E64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8246FF"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgWallet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wallet.7cfd6f183e7bca625543ac33fff61750.svg";